export default __webpack_public_path__ + "static/media/img_4.33696d2f.JPG";